"use client";

// src/components/link/link.tsx
import { tv } from "tailwind-variants";
import {
  trackClickAndRedirect
} from "../../utils/click-tracking.mjs";
import { jsx } from "react/jsx-runtime";
var link = tv({
  base: "text-link hover:underline cursor-pointer"
});
var Link = ({
  ref,
  children,
  as: Component = "a",
  className,
  target,
  track,
  onClick,
  ...rest
}) => {
  const blankRel = /* @__PURE__ */ new Set([
    "noopener",
    "noreferrer",
    ...rest["rel"]?.split(" ") || []
  ]);
  const rel = target === "_blank" ? [...blankRel].join(" ") : rest["rel"] || "";
  return /* @__PURE__ */ jsx(
    Component,
    {
      ref,
      className: link({ className }),
      target,
      rel,
      ...rest,
      onClick: (e) => {
        onClick?.(e);
        trackClickAndRedirect(e, track);
      },
      children
    }
  );
};
export {
  Link
};
